import React, { useState, useEffect, useContext } from "react";
import SmallTeamMessage from "components/teamMessage";
import ActiveStepIndicator from "components/shared/activeStepIndicator";
import { peopleCount } from "utils/constants/onboardingStep";
import classNames from "classnames";
import { MobXProviderContext } from "mobx-react";

const Step1 = ({ disableButton }) => {
  const { onboardingStore } = useContext(MobXProviderContext);

  const [expectedBag, setExpectedBag] = useState(() => {
    const bagCount = onboardingStore.expected_bag;
    if (bagCount == 20) {
      return "20-39";
    } else if (bagCount == 40) {
      return "40-59";
    } else if (bagCount == 60) {
      return "60-79";
    } else if (bagCount == 80) {
      return "80-99";
    } else if (bagCount == 100) {
      return "100+";
    } else {
      return "";
    }
  });

  useEffect(() => {
    disableButton(expectedBag === "" || expectedBag === "<20");
    onboardingStore.handleExpectedBagData(expectedBag);
  }, [expectedBag, disableButton]);

  useEffect(() => {
    onboardingStore.fetchCuisineTypesData();
  }, []);

  return (
    <>
      <ActiveStepIndicator step={1} />

      <div className="flex-col flex gap-6">
        <div className="text-2xl text-gray-800 font-inter-semibold screen-xs:w-full-235">
          <h1>
            Plug in your office’s size and catering needs to see what your meal
            plan on hungerhub will look like!
          </h1>
        </div>
        <div className="expected-bag-text screen-xs:w-full-235 font-inter-semibold">
          <h1>How many people do you expect to order on your meal plan?</h1>
        </div>

        <div className="mb-0.5 w-full screen-xs:w-full-215">
          <div className="screen-lg:inline-flex screen-md:inline-flex">
            {peopleCount.map((value) => (
              <React.Fragment key={value}>
                <div
                  className={classNames(
                    "screen-lg:mr-3 screen-md:mr-3 mt-4 screen-lg:mt-0 screen-md:mt-0 px-4 py-3 hover:cursor-pointer font-inter-medium text-sm leading-[14px] rounded-3xl justify-start gap-2 flex",
                    {
                      "bg-indigo-500 text-white": expectedBag === value,
                      "bg-slate-50 text-slate-700 screen-lg:hover:bg-indigo-500 screen-lg:hover:text-white":
                        expectedBag !== value,
                    }
                  )}
                  onClick={() => setExpectedBag(value)}
                >
                  {value}
                </div>

                {value === "<20" && expectedBag === value && (
                  <div className="hidden screen-lg:hidden screen-md:hidden screen-sm:flex link-div my-4">
                    <SmallTeamMessage />
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>

        {expectedBag === "<20" && (
          <div className="hidden screen-lg:flex screen-md:flex ">
            <div className="link-div">
              <SmallTeamMessage />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Step1;
